import { render, staticRenderFns } from "./VeHrPeixunModal__Style#Drawer.vue?vue&type=template&id=47ffe672&scoped=true"
import script from "./VeHrPeixunModal__Style#Drawer.vue?vue&type=script&lang=js"
export * from "./VeHrPeixunModal__Style#Drawer.vue?vue&type=script&lang=js"
import style0 from "./VeHrPeixunModal__Style#Drawer.vue?vue&type=style&index=0&id=47ffe672&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ffe672",
  null
  
)

export default component.exports